// @flow

import styled, { css } from "styled-components";
import buildColor from "@fdr/static-ui/ColorPalette";
import { fontCondensed, fontNormal, fontBold } from "@fdr/static-ui/Typography";
import Icon from "@fdr/static-ui/Icons";
import { buildText } from "../../_atoms/Text";

export const BetDetailsContainer = styled.div`
  display: flex;
  align-items: flex-start;
`;

export const BetDetails = styled.div`
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  align-items: flex-start;
  justify-items: center;
`;

export const TrashContainer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
`;

export const PromoOptedInWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-top: 2px;
`;

export const PromoOptedInLabel = styled.small`
  font-size: 10px;
  display: inline-block;
  margin-left: 2px;
  text-transform: uppercase;
  color: ${buildColor("grey", "500")};
`;

export const SelectionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 12px;
  ${(props) =>
    props.isVertical
      ? css`
          flex-direction: column;
          justify-content: center;

          & > ol {
            flex-basis: auto;

            &:not(:first-child) {
              margin: 8px 0 0;
            }
          }
        `
      : css`
          flex-flow: row nowrap;
          justify-content: flex-start;
          overflow: auto;

          & > ol {
            flex-basis: 0;

            &:not(:first-child) {
              margin: 0 0 0 8px;
            }
          }
        `};
  ${({ showPotentialReturn }) =>
    showPotentialReturn &&
    css`
      position: relative;
    `};
`;

export const BetSummaryContainer = styled.div`
  position: relative;
  padding-top: 12px;

  &::before {
    content: "";
    position: absolute;
    height: 1px;
    width: ${({ borderWidth }) =>
      !borderWidth ? "calc(100% + 16px)" : "100%"};
    ${({ isBorderBottom }) =>
      isBorderBottom
        ? css`
            bottom: -12px;
          `
        : css`
            top: 0;
          `};
    background: ${buildColor("grey", "300")};
  }
`;

export const BetType = styled.div`
  min-width: 100px;
  margin-right: 12px;
`;

export const TicketAmount = styled.div``;

export const BetLabelWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

export const BetValue = styled.span`
  color: ${(props) => props.color};
  font-family: ${fontNormal};
  font-size: 14px;
  height: 18px;
  line-height: 125%;
  text-align: right;
  ${({ bold }) =>
    bold
      ? css`
          font-family: ${fontBold};
          font-weight: 500;
        `
      : css`
          font-family: ${fontNormal};
          font-weight: normal;
        `};
  font-weight: ${(props) => (props.bold ? "bold" : "normal")};
`;

export const BetLabel = styled.span`
  background-color: ${(props) => props.bgColor};
  color: ${(props) => props.color};
  height: 15px;
  text-align: center;
  line-height: 125%;
  font-size: 12px;
  text-transform: uppercase;
  font-weight: normal;
  border-radius: 2px;
  letter-spacing: 1px;
  font-family: ${fontCondensed};
`;

export const RedCircle = styled.span`
  position: absolute;
  top: 1px;
  right: 1px;
  background-color: ${buildColor("red", "500")};
  width: 4px;
  height: 4px;
  border-radius: 50%;
`;

export const BetInfoTitle = styled(
  buildText({
    tag: "div",
    fontSize: 14,
    color: buildColor("grey", "900")
  })
)`
  text-transform: capitalize;
  height: 18px;
  line-height: 125%;
`;

export const BetInfoSubTitle = styled(
  buildText({
    tag: "div",
    fontSize: 12,
    color: buildColor("grey", "800")
  })
)`
  display: flex;
  letter-spacing: 1px;
  text-transform: uppercase;
  font-family: ${fontCondensed};
  line-height: 125%;
  align-items: flex-end;

  & > span:first-child {
    margin-right: 4px;
  }
`;

export const ProbablesAmount = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: flex-start;
  justify-items: flex-end;

  & > div {
    white-space: nowrap;
    align-self: flex-end;
  }
`;

export const InfoButton = styled(Icon)`
  margin-right: 4px;
`;

export const TagContainer = styled.div`
  margin-left: 12px;
`;
